import { render, staticRenderFns } from "./sample-pictures-import.vue?vue&type=template&id=2084ba12&scoped=true&"
import script from "./sample-pictures-import.vue?vue&type=script&lang=js&"
export * from "./sample-pictures-import.vue?vue&type=script&lang=js&"
import style0 from "./sample-pictures-import.vue?vue&type=style&index=0&id=2084ba12&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084ba12",
  null
  
)

export default component.exports